var map = {
	"./desktop-105.svg": 5806,
	"./desktop-50.svg": 8944,
	"./desktop-65.svg": 6670,
	"./desktop-85.svg": 2898,
	"./formule.svg": 8446,
	"./mobile-105.svg": 2039,
	"./mobile-50.svg": 7487,
	"./mobile-65.svg": 9311,
	"./mobile-85.svg": 7556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6358;